import Component from './RepoCasesTable';
import withQuery from './RepoCasesTable.relay';
export default withQuery(Component);



// WEBPACK FOOTER //
// ./src/packages/@ncigdc/modern_components/RepoCasesTable/index.js